import { defineFetchForNamespace } from '../../redux/fetch';

import { fetchFooter } from '../service';
import { Footer } from '@pegasus/ui-footers/types/content';
import { combineReducers } from 'redux';

export const NAME = 'fetch';
export const NAMESPACE = 'footer';

const { reducer, getIsInitial, getIsLoading, getData, fetchData } = defineFetchForNamespace<
    Footer,
    string,
    typeof NAMESPACE,
    typeof NAME
>(NAMESPACE, NAME, (locale: string) => fetchFooter(locale).then(response => response.results));

const getFooterReducer = () => ({
    [NAMESPACE]: combineReducers({
        [NAME]: reducer,
    }),
});

export {
    getFooterReducer,
    getIsInitial,
    getIsLoading,
    getData as getFooter,
    fetchData as fetchFooter,
};
